/* @flow */
import * as React from 'react';
import Checkbox from 'components/Checkbox';
import stringUtils from 'utils/string';
import { withTranslation } from 'react-i18next';
import styles from './styles.module.scss';

import type { MergeLicenseComponent, Translate } from 'types';

type Props = {
  component: MergeLicenseComponent,
  isSelectable: boolean,
  isSelected: boolean,
  onCheckboxClick?: () => mixed,
  actionButtons?: React.Node,
  t: Translate,
};

type State = {};

class LicenseComponentListRow extends React.PureComponent<Props, State> {
  state = {};

  render() {
    const {
      component,
      isSelectable = true,
      isSelected = false,
      onCheckboxClick,
      actionButtons,
    } = this.props;
    const description = component.description;
    const singleComponents = component.components || [];
    const price = singleComponents.some(c => c.price != null)
      ? singleComponents.reduce((acc, curr) => acc + (curr.price || 0), 0)
      : null;
    const discountedPrice = singleComponents.some(c => c.discountedPrice != null)
      ? singleComponents.reduce((acc, curr) => acc + (curr.discountedPrice || 0), 0)
      : null;

    return (
      <div className={styles.row}>
        {isSelectable && (
          <div className={styles.checkbox}>
            <Checkbox onClick={onCheckboxClick} small={true} checked={isSelected} />
          </div>
        )}
        <div className={styles.description}>{description}</div>
        <div className={styles.price}>{stringUtils.prettifyMoney(price)}</div>
        <div className={styles.discountedPrice}>
          {price && discountedPrice && stringUtils.prettifyMoney(discountedPrice)}
        </div>
        <div className={styles.actionButtons}>{actionButtons}</div>
      </div>
    );
  }
}

export default withTranslation()(LicenseComponentListRow);
